import apiClient from 'commons/api/client/apiClient';
import localeService from 'commons/localeService/localeService';

export default {
  getMpDeeplink(id, options = {}) {
    return apiClient
      .request({
        method: 'GET',
        url: '/shopData/url/detail',
        params: {
          locale: options.locale || localeService.getLocale(),
          id,
        },
      })
      .then((res) => res.data);
  },
};
